import config from 'config/appConfig';
import { DivConst } from 'constants/divConst';
import { DiagnosisRefResponseResultType } from 'types/api/diagnosisResponseType';
import { AppHelper } from './appHelper';

export class DiagnosisHelper {
  /**
   * 診断のプレビューURLを取得します。
   */
  static getPreviewUrl(diagnosisPreviewCd: string): string {
    return `${config.url.userWeb}/diagnosis/preview/${diagnosisPreviewCd}`;
  }

  /**
   * 診断のプレビューURLを開きます。
   */
  static openPreviewUrl(diagnosisPreviewCd: string): void {
    window.open(this.getPreviewUrl(diagnosisPreviewCd), '_blank');
  }

  /**
   * 診断の公開URLを取得します。
   */
  static getProductionUrl(diagnosisCd: string): string {
    return `${config.url.userWeb}/diagnosis/${diagnosisCd}`;
  }

  /**
   * 診断の公開URLを開きます。
   */
  static openProductionUrl(diagnosisCd: string): void {
    window.open(this.getProductionUrl(diagnosisCd), '_blank');
  }

  /**
   * 診断のLINE公開URLを取得します。
   */
  static getLineProductionUrl(diagnosisCd: string): string {
    return `${config.url.userWeb}/diagnosis/line/${diagnosisCd}`;
  }

  /**
   * 診断のLINE公開URLを開きます。
   */
  static openLineProductionUrl(diagnosisCd: string): void {
    window.open(this.getLineProductionUrl(diagnosisCd), '_blank');
  }

  /**
   * 公開期間の文字列を作成します。。
   * 公開予定日よりも公開日を優先して表示します。
   */
  static formatPublishTerm(props: {
    diagnosisStatusDiv: number;
    publishStartAt: number;
    publishEndAt: number;
    publishedAt: number;
    terminatedAt: number;
  }): string {
    let startAt = null;
    let endAt = null;

    // 予約ステータスの場合は、予約日を優先
    if (props.diagnosisStatusDiv == DivConst.items.diagnosisStatus.reserved.value) {
      startAt = props.publishStartAt;
      endAt = props.publishEndAt;
    }
    // その他のステータスの場合は、公開実績を優先
    else {
      startAt = AppHelper.isNotEmpty(props.publishedAt) ? props.publishedAt : props.publishStartAt;

      endAt = AppHelper.isNotEmpty(props.terminatedAt) ? props.terminatedAt : props.publishEndAt;
    }

    if (AppHelper.isEmpty(startAt) && AppHelper.isEmpty(endAt)) {
      return '指定なし';
    }
    if (AppHelper.isEmpty(startAt) && AppHelper.isNotEmpty(endAt)) {
      return `${AppHelper.formatTimeToDate(
        new Date().getTime(),
        'yyyy/MM/dd'
      )} 〜 ${AppHelper.formatTimeToDate(endAt, 'yyyy/MM/dd')}`;
    }
    if (AppHelper.isNotEmpty(startAt) && AppHelper.isEmpty(endAt)) {
      return `${AppHelper.formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 無期限`;
    }

    return `${AppHelper.formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 ${AppHelper.formatTimeToDate(
      endAt,
      'yyyy/MM/dd'
    )}`;
  }

  /**
   * 診断オプションの選択値をidからタイトルに変換
   */
  static convResultListIdToTitle(
    diagnosisResultList: string,
    results: DiagnosisRefResponseResultType[]
  ): string {
    if (!diagnosisResultList || !results) {
      return '';
    }
    const resultIds = diagnosisResultList.split(',');
    const resultTitles = results
      .filter(result => resultIds.includes(result.id.toString()))
      .map(result => encodeURIComponent(result.title));
    return resultTitles.join(',');
  }
  /**
   * 診断オプションの選択値をタイトルからidに変換
   */
  static convResultListTitleToId(
    diagnosisResultList: string,
    results: DiagnosisRefResponseResultType[]
  ): string {
    if (!diagnosisResultList || !results) {
      return '';
    }
    const resultTitles = diagnosisResultList.split(',');
    const resultTitlesConv = resultTitles.map(title => title.trim());
    const resultIds = results
      .filter(result => resultTitlesConv.includes(result.title.toString()))
      .map(result => result.id);
    return resultIds.join(',');
  }
}
